



















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IUser } from "@/models/users";

@Component({
  components: {
    "user-brand-permissions": () =>
      import("@/components/app/admin/users/userBrandPermissions.vue"),
    "user-status-icon": () =>
      import("@/components/app/admin/users/userStatusIcon.vue")
  }
})
export default class UserListItem extends Vue {
  // Props

  @Prop({ default: null })
  public user!: IUser;

  @Prop({ required: true })
  public isLoading!: boolean;

  // Computed

  public get userRoute() {
    if (!this.user) return {};
    return {
      name: "adminUser",
      params: {
        userId: this.user.id
      }
    };
  }
}
